export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'left',
    fixed: 'left',
    width: 110,
    slots: { default: 'opt' },
  },
  {
    field: 'v_funcID',
    align: 'center',
    minWidth: 280,
    title: that.$l('merchant_function_form_language_funcName') || '功能名称',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: { default: 'funcID' },
  },
  {
    field: 'labelKey',
    headerAlign: 'center',
    align: 'left',
    minWidth: 300,
    title: that.$l('merchant_function_form_language_labelKey') || '关键字',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'cn_text',
    headerAlign: 'center',
    align: 'left',
    minWidth: 300,
    title: that.$l('merchant_function_form_language_cn_text') || '中文',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'en_text',
    headerAlign: 'center',
    align: 'left',
    minWidth: 300,
    title: that.$l('merchant_function_form_language_en_text') || '英文',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'jp_text',
    headerAlign: 'center',
    align: 'left',
    width: 250,
    title: that.$l('merchant_function_form_language_jp_text') || '日文',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'creationTime',
    title: that.$l('INDEX.create_date') || '创建时间',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
